import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AppRoute from './AppRoute';

// Layouts
import ClientLayout from '../layouts/DashboardCliente/clientLayout';
import { WebSiteLayout } from '../layouts/Website/WebSiteLayout';
import { HomeLayout } from '../layouts/Website/home/HomeLayout';

// Client Core
import ClientHome from '../views/client';
import ClientProfile from '../views/client/profile';
import ChangePassword from '../views/auth/changePassword';
import ForgotPassword from '../views/auth/forgotPassword';
import Search from '../views/website/search';

// Places & Merchants
import Merchants from '../views/website/merchants';
import MerchantMenu from '../views/website/merchants/menu';
import MerchantMenuProducts from '../views/website/merchants/menuProducts';
import MerchantReview from '../views/website/merchants/review';
import PublicMerchantProfile from '../views/website/merchants/PublicMerchantProfile';
import BusinessCard from '../views/website/merchants/businessCard';

// Events
import Events from '../views/website/events';
import EventsDetails from '../views/website/events/detail';
import EventTickets from '../views/website/events/EventTickets';
import EventsReview from '../views/website/events/review';
import EventsReviewFeriaTurismo from '../views/website/events/feriaTurismo';
import EventsGastromedia from '../views/website/events/gastromedia';
import Ticket from '../views/client/events/ticket';
import TicketsList from '../views/client/events/tickets';

// E-commerce & Client features
import CartPage from '../views/client/commerce/CartPage';
import CheckoutPage from '../views/client/commerce/CheckoutPage';
import ClientOrdersPage from '../views/client/orders';
import ClientOrderDetailPage from '../views/client/orders/OrderDetailPage';
import ClientCoupons from '../views/client/coupons';
import MySubscriptions from '../views/client/subscriptions';
import SubscriptionDetail from '../views/client/subscriptions/SubscriptionDetail';
import ClientReservationsPage from '../views/client/bookings/ReservationsPage';

// Workspaces
import WorkspacesSelection from '../views/client/workspaces/WorkspacesSelection';
import WorkspaceContainer from '../views/client/workspaces/WorkspacesContainer'; // Si lo usas más adelante
import WorkspaceEvents from '../views/client/workspaces/WorkspacesEvents';
import WorkspaceDashboard from '../views/client/workspaces/WorkspaceDashboard';

// Allies & Transports
import TransportBooking from '../views/website/transporte/Booking';
import TransportBooking2 from '../views/website/transporte/Booking2';
import Artemis from '../views/taxi/Artemis';
import MamaAzul from '../views/website/allies/mamaazul';
import JorgeSilvaCook from '../views/website/allies/exitart/JorgeSilva';
import GastromediaAlly from '../views/website/allies/gastromedia';
import Hamburger from '../views/website/allies/tastyFest/hamburger';

// Legal
import Privacy from '../views/legal/privacy';
import TermsAndConditions from '../views/legal/terms';
import DeleteUser from '../views/legal/deleteUser';

export default function ClientNavigation() {
    return (
        <Switch>
            <AppRoute exact path='/' layout={ClientLayout} component={ClientHome} />
            <AppRoute exact path='/dashboard' layout={ClientLayout} component={ClientHome} />
            <AppRoute exact path='/profile' layout={ClientLayout} component={ClientProfile} />
            <AppRoute exact path='/security/changepassword' layout={ClientLayout} component={ChangePassword} />
            
            {/** Search */}
            <AppRoute exact path='/search/:category/:location?' layout={ClientLayout} component={Search} />

            {/** Transport & Allies */}
            <AppRoute exact path='/transporte' layout={ClientLayout} component={TransportBooking} />
            <AppRoute exact path='/transporte/2' layout={ClientLayout} component={TransportBooking2} />
            <AppRoute exact path='/artemis' layout={WebSiteLayout} component={Artemis} />
            <AppRoute exact path='/mamaazul' layout={ClientLayout} component={MamaAzul} />
            <AppRoute exact path='/Asa2workshop' layout={ClientLayout} component={JorgeSilvaCook} />
            <AppRoute exact path='/tastyfest' layout={ClientLayout} component={Hamburger} />
            <AppRoute exact path='/gastromedia' layout={ClientLayout} component={GastromediaAlly} />

            {/** Commerce & Features */}
            <AppRoute exact path='/cart' layout={ClientLayout} component={CartPage} />
            <AppRoute exact path='/checkout' layout={ClientLayout} component={CheckoutPage} />
            <AppRoute exact path='/coupons' layout={ClientLayout} component={ClientCoupons} />
            <AppRoute exact path='/subscriptions' layout={ClientLayout} component={MySubscriptions} />
            <AppRoute exact path='/subscriptions/detail/:id' layout={ClientLayout} component={SubscriptionDetail} />
            <AppRoute exact path='/orders' layout={ClientLayout} component={ClientOrdersPage} />
            <AppRoute exact path='/orders/:id' layout={ClientLayout} component={ClientOrderDetailPage} />
            <AppRoute exact path='/reservations' layout={ClientLayout} component={ClientReservationsPage} />
            <AppRoute exact path='/smartcards' layout={WebSiteLayout} component={ForgotPassword} />
            <AppRoute exact path='/businesscard/:uuid' layout={ClientLayout} component={BusinessCard} />

            {/** Merchants & Places */}
            <AppRoute exact path='/merchants' layout={ClientLayout} component={Merchants} />
            <AppRoute exact path='/merchants/:uuid/review' layout={ClientLayout} component={MerchantReview} />
            
            {/* NUEVAS RUTAS DE PLACES (Espejo de la App Móvil) */}
            <AppRoute exact path='/places/:uuid' layout={ClientLayout} component={PublicMerchantProfile} />
            <AppRoute exact path='/places/:uuid/review' layout={ClientLayout} component={MerchantReview} />
            <AppRoute exact path='/places/:uuid/catalog' layout={ClientLayout} component={MerchantMenu} />
            <AppRoute exact path='/places/:uuid/catalog/:category_uuid' layout={ClientLayout} component={MerchantMenuProducts} />

            {/** Events */}
            <AppRoute exact path='/tickets' layout={ClientLayout} component={TicketsList} />
            <AppRoute exact path='/ticketing/:uuid' layout={ClientLayout} component={Ticket} />

            {/* NUEVAS RUTAS DE EVENTS (En Inglés) */}
            <AppRoute exact path='/events' layout={ClientLayout} component={Events} />
            <AppRoute exact path='/events/:id' layout={ClientLayout} component={EventsDetails} />
            <AppRoute exact path='/events/:id/tickets' layout={ClientLayout} component={EventTickets} />
            <AppRoute exact path='/events/:id/review' layout={ClientLayout} component={EventsReview} />
            <AppRoute exact path='/events/:id/review/feriaturismo' layout={HomeLayout} component={EventsReviewFeriaTurismo} />
            <AppRoute exact path='/events/:id/tastyfest/:producto_evento_uuid' layout={ClientLayout} component={EventsGastromedia} />

            {/* --- SALVAVIDAS SEO Y QR (Redirecciones) --- */}
            {/* Merchants */}
            <Redirect exact from="/merchants/:uuid/menu/:category_uuid" to="/places/:uuid/catalog/:category_uuid" />
            <Redirect exact from="/merchants/:uuid/review" to="/places/:uuid/review" />
            <Redirect exact from="/merchants/:uuid/menu" to="/places/:uuid/catalog" />
            <Redirect exact from="/merchants/:uuid/profile" to="/places/:uuid" />
            <Redirect exact from="/merchants/:uuid" to="/places/:uuid" />

            {/* Events */}
            <Redirect exact from="/eventos/:id/tickets" to="/events/:id/tickets" />
            <Redirect exact from="/eventos/:id/review/feriaturismo" to="/events/:id/review/feriaturismo" />
            <Redirect exact from="/eventos/:id/review" to="/events/:id/review" />
            <Redirect exact from="/eventos/:id/tastyfest/:producto_evento_uuid" to="/events/:id/tastyfest/:producto_evento_uuid" />
            <Redirect exact from="/eventos/:id" to="/events/:id" />
            <Redirect exact from="/eventos" to="/events" />

            {/** Workspaces */}
            <Route exact path="/workspaces" component={WorkspacesSelection} />
            <Route exact path="/workspaces/:uuid" component={WorkspaceDashboard} />
            <Route exact path="/workspaces/:uuid/events" component={WorkspaceEvents} />
            <Route exact path="/workspaces/:uuid/events/:eventId" component={WorkspaceEvents} />

            {/** Legal */}
            <AppRoute exact path='/privacy' layout={ClientLayout} component={Privacy} />
            <AppRoute exact path='/termsandconditions' layout={ClientLayout} component={TermsAndConditions} />
            <AppRoute exact path='/deleteUser' layout={ClientLayout} component={DeleteUser} />

            <Route path="*">
                <Redirect to="/"/>
            </Route>
        </Switch>
    )
}